import React, { useState } from 'react';
import EnterpriseTable from '../components/EnterpriseTable';
import api from '../services/api';
import { Box, Typography, Stack, TextField, Button } from '@mui/material';
import { Download } from '@mui/icons-material';
import PageHeader from '../components/PageHeader';

export default function AuditLog() {
  const [actionFilter, setActionFilter] = useState('');
  const [actorFilter, setActorFilter] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const fetchData = async ({ page, limit }) => {
    const params = { page, limit };
    if (actionFilter) params.action = actionFilter;
    if (actorFilter) params.userId = actorFilter; // allow passing userId
    if (from) params.from = from;
    if (to) params.to = to;
    const res = await api.get('/audit', { params });
    return { data: res.data.data || [], total: res.data.total || 0, pages: res.data.pages || 1 };
  };

  const handleExport = async () => {
    const params = {};
    if (actionFilter) params.action = actionFilter;
    if (actorFilter) params.userId = actorFilter;
    if (from) params.from = from;
    if (to) params.to = to;
    const res = await api.exportAudits(params);
    const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `audits_${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Box>
      <PageHeader
        title="Audit Log"
        subtitle="Review admin activity, filter events, and export audit records for compliance."
        gradient="linear-gradient(90deg, #475569, #94A3B8)"
        actions={<Button size="small" startIcon={<Download />} variant="outlined" onClick={handleExport}>Export CSV</Button>}
      />

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }}>
        <TextField label="Action" value={actionFilter} onChange={e => setActionFilter(e.target.value)} size="small" />
        <TextField label="Actor (userId)" value={actorFilter} onChange={e => setActorFilter(e.target.value)} size="small" />
        <TextField label="From (YYYY-MM-DD)" value={from} onChange={e => setFrom(e.target.value)} size="small" />
        <TextField label="To (YYYY-MM-DD)" value={to} onChange={e => setTo(e.target.value)} size="small" />
      </Stack>

      <EnterpriseTable
        columns={[
          { id: 'timestamp', label: 'Time', render: (r) => new Date(r.timestamp).toLocaleString() },
          { id: 'actor', label: 'Actor', render: (r) => r.userId?.name || r.userId || 'System' },
          { id: 'action', label: 'Action', render: (r) => r.action },
          { id: 'resource', label: 'Resource', render: (r) => r.resource || '-' },
          { id: 'details', label: 'Details', render: (r) => r.details ? JSON.stringify(r.details) : '-' },
        ]}
        fetchData={fetchData}
        initialLimit={25}
      />
    </Box>
  );
}
